"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _ButtonBase = _interopRequireDefault(require("../ButtonBase"));
var _tss = require("../styles/tss");
var _capitalizeFirstWord = require("../utilities/capitalizeFirstWord");
const _excluded = ["textTransform"],
  _excluded2 = ["textTransform"],
  _excluded3 = ["classes", "className", "disabled", "iconDirection", "fullWidth", "icon", "indicator", "label", "onChange", "onClick", "onFocus", "selected", "selectionFollowsFocus", "size", "textColor", "value", "wrapped"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const useStyles = (0, _tss.makeTssStyles)({
  name: 'DsTab',
  uniqId: 'fyKK4C'
})((theme, _params, classes) => {
  const {
    spacing,
    colors,
    typography
  } = theme.busbud;
  const _typography$font$comp = typography.font.component.label.md,
    {
      textTransform: textTransformMd
    } = _typography$font$comp,
    labelMd = (0, _objectWithoutProperties2.default)(_typography$font$comp, _excluded);
  const _typography$font$comp2 = typography.font.component.label.lg,
    {
      textTransform: textTransformLg
    } = _typography$font$comp2,
    labelLg = (0, _objectWithoutProperties2.default)(_typography$font$comp2, _excluded2);
  return {
    /* Styles applied to the root element. */
    root: _objectSpread(_objectSpread({}, labelMd), {}, {
      // Error on casting string to a valid textTransform value
      // TODO remove when legacy theme is removed
      textTransform: textTransformMd,
      fontWeight: 'bold',
      maxWidth: spacing(30),
      position: 'relative',
      flexShrink: 0,
      overflow: 'hidden',
      whiteSpace: 'normal',
      textAlign: 'center'
    }),
    /* Styles applied to the root element if both `icon` and `label` are provided. */
    labelIcon: {
      [`&.${classes.horizontal} &.${classes.wrapper} > *:first-child`]: {
        marginRight: spacing(0.25)
      },
      [`&.${classes.vertical}`]: {
        paddingTop: spacing(1),
        [`.${classes.wrapper} > *:first-child`]: {
          marginBottom: spacing(0.75)
        }
      }
    },
    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="inherit"`. */
    textColorInherit: {
      color: colors.text.primary.opaque,
      [`&.${classes.selected}`]: {
        opacity: 1,
        color: colors.component.tab.text.primary.selected
      },
      [`&.${classes.disabled}`]: {
        opacity: 0.5
      }
    },
    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="primary"`. */
    textColorPrimary: {
      color: colors.text.primary.opaque,
      [`&.${classes.selected}`]: {
        color: colors.component.tab.text.primary.selected
      },
      [`&.${classes.disabled}`]: {
        color: colors.component.tab.text.primary.disabled
      }
    },
    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="secondary"`. */
    textColorSecondary: {
      color: colors.text.secondary.opaque,
      [`&.${classes.selected}`]: {
        color: colors.component.tab.text.secondary.selected
      },
      [`&.${classes.disabled}`]: {
        color: colors.component.tab.text.secondary.disabled
      }
    },
    /* Pseudo-class applied to the root element if `selected={true}` (controlled by the Tabs component). */
    selected: {},
    /* Pseudo-class applied to the root element if `disabled={true}` (controlled by the Tabs component). */
    disabled: {},
    /* Styles applied to the root element if `fullWidth={true}` (controlled by the Tabs component). */
    fullWidth: {
      flexShrink: 1,
      flexGrow: 1,
      flexBasis: 0,
      maxWidth: 'none'
    },
    sizeSm: {
      minWidth: spacing(15),
      minHeight: spacing(5),
      padding: spacing(1.5, 1)
    },
    sizeMd: {
      minWidth: spacing(20),
      minHeight: spacing(6),
      padding: spacing(2, 1.5)
    },
    sizeLg: _objectSpread(_objectSpread({}, labelLg), {}, {
      // Error on casting string to a valid textTransform value
      // TODO remove when legacy theme is removed
      textTransform: textTransformLg,
      minWidth: spacing(30),
      minHeight: spacing(8),
      padding: spacing(2.5, 2)
    }),
    /* Styles applied to the root element if `wrapped={true}`. */
    wrapped: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: 1.5
    },
    /* Styles applied to the `icon` and `label`'s wrapper element. */
    wrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      flexDirection: 'column',
      [`&.${classes.horizontal}`]: {
        display: 'flex',
        flexDirection: 'row'
      }
    },
    horizontal: {},
    vertical: {},
    icon: {
      color: colors.icon.primary.opaque,
      [`&.${classes.selected}`]: {
        color: colors.component.tab.text.primary.selected
      }
    }
  };
});
/**
 * Individual tab component for use inside the `Tabs` component.
 */
const Tab = /*#__PURE__*/React.forwardRef(function Tab(props, ref) {
  const {
      classes: classesOverrides,
      className,
      disabled = false,
      iconDirection = 'vertical',
      fullWidth,
      icon,
      indicator,
      label,
      onChange,
      onClick,
      onFocus,
      selected,
      selectionFollowsFocus,
      size = 'md',
      textColor = 'inherit',
      value,
      wrapped = false
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded3);
  const {
    cx,
    classes
  } = useStyles(undefined, {
    props: {
      classes: classesOverrides
    }
  });
  const handleClick = event => {
    if (!selected && onChange) {
      onChange(event, value);
    }
    if (onClick) {
      onClick(event);
    }
  };
  const handleFocus = event => {
    if (selectionFollowsFocus && !selected && onChange) {
      onChange(event, value);
    }
    if (onFocus) {
      onFocus(event);
    }
  };
  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
    "data-testid": "tab",
    className: cx(classes.root, classes[`textColor${(0, _capitalizeFirstWord.capitalizeFirstWord)(textColor)}`], classes[`size${(0, _capitalizeFirstWord.capitalizeFirstWord)(size)}`], classes[iconDirection], {
      [classes.disabled]: disabled,
      [classes.selected]: selected,
      [classes.labelIcon]: !!label && !!icon,
      [classes.fullWidth]: fullWidth,
      [classes.wrapped]: wrapped
    }, className),
    ref: ref,
    role: "tab",
    "aria-selected": selected,
    disabled: disabled,
    onClick: handleClick,
    onFocus: handleFocus,
    tabIndex: selected ? 0 : -1
  }, other), /*#__PURE__*/React.createElement("span", {
    className: cx(classes.wrapper, classes[iconDirection])
  }, icon, label), indicator);
});
var _default = exports.default = Tab;